var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyHubIcon = function SvgMyHubIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "myHubIcon_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 65.2 65.2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".myHubIcon_svg__cls-1{fill:none;stroke:#12263f;stroke-miterlimit:10}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.44 32.89 32.6 14.32 12.76 32.89",
    className: "myHubIcon_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.72 31.73v19.48h9.92V39.44h9.92v11.77h9.92V31.73",
    className: "myHubIcon_svg__cls-1"
  })));
};
export default SvgMyHubIcon;